
import React, {useEffect, useState} from "react";
import QRCode from "qrcode";
import {projectUrl} from "../../../Config/SharedConfig";
import {useNavigate} from "react-router-dom";
import ToolBar from "../../../Components/Elements/ToolBar";
import {getStoreName} from "../../../Components/Utils/getStoreName";
import ButtonPrimary from "../../../Components/Elements/ButtonPrimary";


const QRCodeGenerator = () => {

    const storeUsername = getStoreName()

    const [qrCodeURL , setQRCodeURL] = useState("")

    const navigate = useNavigate()

    const handleDownload = () => {
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = qrCodeURL;
        link.download = storeUsername + "-qrcode.png";
        link.click();
        document.body.removeChild(link);
    };


    useEffect(() => {
        const options = {
            type: `image/png`,
            error : "Q",
            scale : 10,
            width : 2048
        };
        QRCode.toDataURL(`https://${storeUsername}.${projectUrl}` , options)
            .then(url => {
                setQRCodeURL(url)
            })
            .catch(err => {
                console.error(err)
            })
    } , [])

    return(
        <>
            <ToolBar title="کیوآر کدساز فروشگاه" navigate={() => navigate(-1)} />
            <div className="container">
                <div className="row justify-content-center mt-32">
                    <div className="col-8">
                        <div className="qr-code-cnt">
                            <img src={qrCodeURL} className="qr-code" alt={`https://${storeUsername}.${projectUrl}`} />
                        </div>
                    </div>
                </div>
            </div>


            <div className='btn-fixed-bottom dir-rtl'>
                <ButtonPrimary mode='dark-mode'
                               onclick={handleDownload}
                               text={`دریافت فایل`}
                               isLoading={false} />
            </div>
        </>
    )
}

export default QRCodeGenerator